import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

interface HotelCategoriesParams {
  hotelClass?: string;
}

export function hotelCategories(criteria: SearchCriteria | PartialSearchCriteria): HotelCategoriesParams {
  if (criteria.hotelCategories?.length) {
    return { hotelClass: criteria.hotelCategories.join('.') };
  }
  return {};
}
